import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0A2342] text-[#FBF9F6] mt-24"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="font-serif-display text-3xl md:text-4xl leading-tight">
                        Crown &amp; Oak
                    </div>
                    <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#FBF9F6]/70">
                        Hand-stitched heritage. Small-batch needlepoint key fobs
                        crafted with cream canvas, cognac leather, and polished
                        hardware.
                    </p>
                </div>
                <div>
                    <h4 className="text-[11px] tracking-[0.22em] uppercase font-medium text-[#FBF9F6]/60 mb-4">
                        Shop
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link
                                data-testid="footer-link-shop"
                                to="/shop"
                                className="hover:text-[#9E5A35]"
                            >
                                All Fobs
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-link-about"
                                to="/about"
                                className="hover:text-[#9E5A35]"
                            >
                                Our Story
                            </Link>
                        </li>
                        <li>
                            <Link
                                data-testid="footer-link-contact"
                                to="/contact"
                                className="hover:text-[#9E5A35]"
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-[11px] tracking-[0.22em] uppercase font-medium text-[#FBF9F6]/60 mb-4">
                        Elsewhere
                    </h4>
                    <div className="flex items-center gap-4">
                        <a
                            data-testid="footer-instagram"
                            href="https://instagram.com/crownandoakcompany"
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-[#9E5A35]"
                            aria-label="Instagram"
                        >
                            <Instagram size={20} strokeWidth={1.5} />
                        </a>
                        <a
                            data-testid="footer-email"
                            href="mailto:crownandoakcompany@gmail.com"
                            className="hover:text-[#9E5A35]"
                            aria-label="Email"
                        >
                            <Mail size={20} strokeWidth={1.5} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-6 text-xs text-[#FBF9F6]/50 flex flex-col md:flex-row items-center justify-between gap-2">
                    <span>
                        © {new Date().getFullYear()} Crown &amp; Oak. All rights
                        reserved.
                    </span>
                    <span className="tracking-[0.22em] uppercase text-[10px]">
                        Est. 2026 · Handcrafted in Singapore
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
